import { KampaayDataProvider } from 'services/api/dataProvider'
import { isDev } from 'services/env'
import { pocMap } from './factory'

const isSymbol = (name: string | symbol): name is symbol =>
  typeof name === 'symbol'

/**
 * This function is used to create a proxy for the kampaayDataProvider.
 * It will intercept all calls for resources defined in the pocMap having an handler
 * defined there and will call the handler instead of the original function.
 *
 * @param dataProvider
 * @returns
 */
const proxyDataProvider = (dataProvider: KampaayDataProvider) =>
  new Proxy(dataProvider, {
    get: (_target, name) => {
      return (res: any, params: any) => {
        if (!isSymbol(name) && res in pocMap) {
          const handler = pocMap[res].dp[name]
          if (handler) {
            return handler(res, params)
          } else {
            throw new Error(
              `Method ${name} not implemented for resource ${res}`
            )
          }
        }
        return dataProvider[name as any](res, params)
      }
    },
  })

export const proxyDpPoc = (kampaayDataProvider: KampaayDataProvider) =>
  isDev ? proxyDataProvider(kampaayDataProvider) : kampaayDataProvider
